import { render, staticRenderFns } from "./ImportOrders.vue?vue&type=template&id=5b7e442d&scoped=true"
import script from "./ImportOrders.vue?vue&type=script&lang=js"
export * from "./ImportOrders.vue?vue&type=script&lang=js"
import style0 from "./ImportOrders.vue?vue&type=style&index=0&id=5b7e442d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e442d",
  null
  
)

export default component.exports